import {InjectionToken} from "@angular/core";

export const LOGIN_TOKEN = new InjectionToken<string>('LOGIN_TOKEN');

export const tokenProviders = [
  {provide: LOGIN_TOKEN, useValue: 'LOGIN_TOKEN'}
];
